$(document).ready(() => {
    // often bought together
    $(".suggested__buyBtn").on("click", (el)=>{
        $(el.currentTarget).find("span").hide();
        $(el.currentTarget).find(".show-spinner").show();
    
        jQuery.post("/cart/add.js", {
            quantity: 1,
            id: $(el.currentTarget).data("product")
        }).done((data)=>{
            window.location.reload();
        })
    });
    
    // color selector

    $(".colors-picker .color").on("click", (ev)=>{
        $(".colors-picker .color-selected").removeClass("color-selected");
        $(ev.currentTarget).addClass("color-selected");
        $("#color_picker").val($(ev.currentTarget).data("val"))
    });

    const parent = $(".main-product");

    if (parent.find("#upload-btn") != null) {
        parent.find("#custom_image").on("change", (ev) => {
            if (ev.target.files.length != 0) {
                const filename = ev.target.files[0].name;
                parent.find(".product-form__submit").prop("disabled", false);
                parent.find("#upload-photo-name").text("(" + filename + ")");
            } else {
                parent.find(".product-form__submit").prop("disabled", true);
                parent.find("#upload-photo-name").text("");

                //$("#upload-photo-name").html("-");
            }
        })
    }

    parent.find("#upload-btn").on("click", () => {
        parent.find("#custom_image").click();
    });


    parent.find("input[name='variant']").on("change", (el) => {
        const val = $(el.target).data("variant");
        const price = $(el.target).data("price");
        const compare_at_price = $(el.target).data("compare-at-price");
        const sale_percentage = $(el.target).data("sale-percentage");
        const diff = $(el.target).data("price-diff");
        const symbol = $(el.target).data("symbol");
        parent.find("input[name='id']").val(val);
        window.history.replaceState({}, '', `?variant=${val}`);
        parent.find(".prices .price span").text(symbol + (price / 100).toFixed(2));
        if (compare_at_price == "" || diff == 0) {
            //hide
            parent.find(".action-price .standard-price").hide();
            parent.find(".action-price .save-price").hide();
            
        } else {
            //show
            parent.find(".action-price .standard-price").show();
            parent.find(".action-price .save-price").show();
            parent.find(".action-price .standard-price span").text(symbol + (compare_at_price / 100).toFixed(2));
            parent.find(".action-price .save-price span").text(symbol + (diff / 100).toFixed(2) + " (" + sale_percentage + " %)" );
        }

    });

    parent.on("click", ".p-mini-image", (ev) => {
        console.log("click");
        parent.find(".p-mini-image").removeClass("active");
        $(ev.currentTarget).addClass("active");
        console.log(ev.currentTarget);
        console.log($(ev.target).data("src"));
        console.log($(ev.target).data("index"));
        parent.find("#p-main-image").attr("src", $(ev.target).data("src"));
        parent.find("#p-main-image").data("index", $(ev.target).data("index"));
    });
    var srcArr = [];
    let fbShareUrl = window.location.href;
    let pinShareUrl = window.location.href;
    if (window.location.pathname == "/") {
        fbShareUrl = window.location.hostname + "/products/diamond-painting-dein-eigenes-foto";
        pinShareUrl = window.location.hostname + "/products/diamond-painting-dein-eigenes-foto";
    }
    parent.find(".p-mini-image").each((index, elem) => {
        srcArr.push({
            pinterestShareUrl: pinShareUrl,
            facebookShareUrl: fbShareUrl, 
            src: $(elem).attr("href"),
            thumb: $(elem).data("thumb")
        });
    })

    parent.find("#p-main-image, .p-image-wrapper .click-to-zoom, .p-image-wrapper .last-product-flag").click(() => {
        var index = parent.find("#p-main-image").data("index");
        dynamicGallery.openGallery(index);
    })

    const $dynamicGallery = parent.find("#dynamic-gallery-main-product");

    const dynamicGallery = lightGallery(document.getElementById("dynamic-gallery-main-product"), {
        dynamic: true,
        dynamicEl: srcArr,
        plugins: [lgZoom, lgThumbnail, lgFullscreen, lgShare],
        licenseKey: 'FCCD110B-9A83497E-A9FE0A57-2F15D111',
        speed: 500,
        download: false,
        fullscreen: true,
        mobileSettings: { showCloseIcon: true },
        strings: { 
            closeGallery: 'Schließen',
            previousSlide: 'Vorheriges',
            nextSlide: 'Nächstes',
        },
        fullscreenPluginStrings: {
            toggleFullscreen: 'Zum Vollbild umschalten'
        },
        zoomPluginStrings: 	{ 
            zoomIn: 'Vergrößern/Verkleinern',
            zoomOut: 'Vergrößern/Verkleinern',
            viewActualSize: 'Translation missing: de.our.lightgallery.view_acutal_size'
        },
        sharePluginStrings: {
            share: 'Teilen'
        },
        showZoomInOutIcons: true,
        actualSize: false,
        twitter: false,
        scale: 2
    });

    if (window.screen.availWidth < 768 && $(".p-mini-images").children().length > 4) {
        $(".p-mini-images").slick({
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            arrows: true,
            lazyLoad: "ondemand",
            responsive: [{
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4
                }
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4
                }
            }]
        });
    }

    // Product quantity limit handle
    resolveProductAvailability();
    $('.jsQuantityInput').change(function(){
        resolveProductAvailability(); 
    });
    $('.jsQuantityInput').keyup(function(){
        resolveProductAvailability(); 
    });
});

function resolveProductAvailability() {
    console.log('resolveProductAvailability', 1532);
    const quantityEl = $('.jsQuantityInput').first();
    const selectedQuantity = quantityEl.val();
    const inventoryQuantity = quantityEl.data('quantity');
    const inventoryPolicy = quantityEl.data('policy');
    const inventoryManagement = quantityEl.data('management');
    const productLimitEl = $('#jsProductLimitError');
    let disableAddToCartOption = false;

    productLimitEl.hide();

    if(inventoryPolicy !== 'deny' || inventoryManagement !== 'shopify') {
        return;
    }

    if(selectedQuantity > inventoryQuantity || selectedQuantity == 0) {
        disableAddToCartOption = true;
    }

    $('#addToCartBtn').prop('disabled', disableAddToCartOption);
    $('.shopify-payment-button__button').prop('disabled', disableAddToCartOption);
    $('#add-to-cart').prop('disabled', disableAddToCartOption);
    if(disableAddToCartOption) {
        productLimitEl.show();
    }
}
